import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {

  configUrl = 'assets/config.json';

  constructor(private _httpClient: HttpClient) { }

  getConfig() {
    return this._httpClient.get<any>(this.configUrl);
  }

  private getAuthHeaders() {
    

    return {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + (localStorage.getItem('userAccessToken') || ''),
    };
  }

  private getJsonHeaders() {
    return {
      'Content-Type': 'application/json',
    };
  }

  getFormDataHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', '*');
    headers = headers.set('Authorization', 'Bearer ' + (localStorage.getItem('userAccessToken') || ''));
    return headers;
  }

  getEmployee() {
    const href = environment.AUTH_API_URL + 'mssql/employees/'
      + localStorage.getItem('agencycode');

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  getEmployeeShift(startDate: string, endDate: string, EmployeeID: string) {
    const href =
      environment.AUTH_API_URL + 'mssql/employee/shift?startDate='
      + startDate + '&endDate=' + endDate + '&EmployeeID=' + EmployeeID
      + '&dbName=' + localStorage.getItem('agencycode');

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  getEmployeeReplacement(
    workHeaderId: number,
    WorkLoadId: null,
    Distance: number = 50
  ) {
    const href = environment.AUTH_API_URL + 'mssql/employee/replacement?workHeaderId='
      + workHeaderId + '&WorkLoadId=' + WorkLoadId + '&Distance=' + Distance
      + '&dbName=' + localStorage.getItem('agencycode');

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  Login(data: any): Observable<any> {
    const href = environment.AUTH_API_URL + 'aws-auth/login';

    return this._httpClient.post<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  VerifyCognito(data: any): Observable<any> {
    const href = environment.AUTH_API_URL + 'aws-auth/verifyCognito';

    return this._httpClient.post<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  onboardingAgency(data: any): Observable<any> {
    const href =
      environment.AUTH_API_URL + 'aws-auth/onboard/' + data.agencycode;

    return this._httpClient.post<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  getProfile(data: any): Observable<any> {
    const href =
      environment.AUTH_API_URL + 'aws-auth/getProfile';

    return this._httpClient.post<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  getProfileEmail(data: any): Observable<any> {
    const href =
      environment.AUTH_API_URL + 'aws-auth/getProfileEmail';

    return this._httpClient.post<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  ConfirmSignUp(data: any): Observable<any> {
    const href = environment.AUTH_API_URL + 'aws-auth/confirmSignup';

    return this._httpClient.post<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  resendCode(data: any): Observable<any> {
    const href = environment.AUTH_API_URL + 'aws-auth/resendCode';

    return this._httpClient.post<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  forgotPassword(data: any): Observable<any> {
    const href = environment.AUTH_API_URL + 'aws-auth/forgotPassword';

    return this._httpClient.post<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  confirmPassword(data: any): Observable<any> {
    const href = environment.AUTH_API_URL + 'aws-auth/confirmPassword';

    return this._httpClient.post<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  renewToken() {
    const href = environment.AUTH_API_URL + 'aws-auth/renewToken';

    const data = {
      Username: localStorage.getItem('userEmail'),
      Refreshtoken: localStorage.getItem('userRefreshToken'),
    };

    return this._httpClient.post<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  checkRealmRole(data: any) {
    const href = environment.AUTH_API_URL + 'user-realm/checkRealmRole';

    return this._httpClient.post<any>(href, data, {
      headers: this.getAuthHeaders(),
    });
  }

  magicLogin(data: any) {
    const href = environment.AUTH_API_URL + 'aws-auth/magic/login';

    return this._httpClient.post<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  updateAttributes(data: any) {
    const href = environment.AUTH_API_URL + 'aws-auth/update';

    return this._httpClient.put<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  addPushToken(data: any) {
    const href = environment.AUTH_API_URL + 'aws-auth/push/token';

    return this._httpClient.put<any>(href, data, {
      headers: this.getJsonHeaders(),
    });
  }

  removePushToken(data: any) {
    const href = environment.AUTH_API_URL + 'aws-auth/push/token';

    return this._httpClient.delete<any>(href, {
      body: data, headers: this.getJsonHeaders(),
    });
  }

  getUsers(search?: string, limit?: number) {
    const loginUserRole = localStorage.getItem('Role');
    const agencycode = localStorage.getItem('agencycode');
    let href = environment.AUTH_API_URL + 'user-realm?Realm=Sembracare&page='
      + 0 + '&limit=' + limit + '&Role=' + loginUserRole + '&agencycode=' + agencycode;

    if (search)
      href = href + '&s=' + search;

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  getUsersAll(search?: string) {
    let href = environment.AUTH_API_URL + 'user/all?isAll=true'
    if (search) {
      href = href + '&s=' + search;
    }

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  deleteUserRealm(data: any) {
    const href = environment.AUTH_API_URL + 'user-realm/deleteRealm';

    return this._httpClient.post<any>(href, data, {
      headers: this.getAuthHeaders(),
    });
  }

  updateProfilePic(data: any) {
    const href = environment.AUTH_API_URL + 'user/profile/picture';
    return this._httpClient.put<any>(href, data, {
      headers: this.getAuthHeaders(),
    });
  }

  updateNotificationPreferences(data: any) {
    const href = environment.AUTH_API_URL + 'user/profile/notificationPreferences';
    return this._httpClient.put<any>(href, data, {
      headers: this.getAuthHeaders(),
    });
  }

  getUnreadCounts(toUserId: string) {
    const requestUrl =
      environment.AUTH_API_URL + 'chat/unreadCount/?toUserId=' + toUserId;
    return this._httpClient.get<any[]>(requestUrl, {
      headers: this.getFormDataHeaders(),
    });
  }

  getConnections(loginuser: string, search?: string) {
    let requestUrl = environment.AUTH_API_URL + 'connections?fromUserId=' + loginuser;
    if (search) {
      requestUrl = requestUrl + '&s=' + search;
    }
    return this._httpClient.get<any[]>(requestUrl, {
      headers: this.getFormDataHeaders(),
    });
  }

  getUploadedFile(fileName: string) {
    const requestUrl = environment.AUTH_API_URL + 'fileupload/' + fileName;
    return this._httpClient.get(requestUrl, {
      headers: this.getFormDataHeaders(),
      reportProgress: true,
      observe: 'events',
      responseType: 'blob',
    });
  }

  upload(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('files', file);

    const req = new HttpRequest(
      'POST',
      `${environment.AUTH_API_URL}fileupload`,
      formData,
      {
        reportProgress: true,
        responseType: 'json',
        headers: this.getFormDataHeaders(),
      }
    );

    return this._httpClient.request(req);
  }

  getShifts(search?: string, shiftIds?: string[]) {
    let href = environment.AUTH_API_URL + 'shifts?page=' + 0 + '&limit=' + 100;

    if (search) {
      href = href + '&s=' + search;
    }

    if (shiftIds) {
      for (let index = 0; index < shiftIds.length; index++) {
        const element = shiftIds[index];
        href = href + '&shiftIds=' + element;
      }
    }

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  getShiftPost(search?: string, shiftIds?: string[]) {
    let href = environment.AUTH_API_URL + 'shifts/search';

    const body = {
      page: 0,
      limit: 100,
    } as any;

    if (search) {
      body['s'] = search;
    }

    if (shiftIds) {
      body['shiftIds'] = shiftIds;
    }

    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  addShift(body: any) {
    const href = environment.AUTH_API_URL + 'shifts';

    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  updateShiftNotes(body: any) {
    const href = environment.AUTH_API_URL + 'shifts/updateNotes';

    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  addUserShift(data: any): Observable<any> {
    const href = environment.AUTH_API_URL + 'user-shifts/update/mutiple';

    return this._httpClient.post<any>(href, data, {
      headers: this.getAuthHeaders(),
    });
  }

  deleteAllShift(): Observable<any> {
    const href = environment.AUTH_API_URL + 'user-shifts/all/data';

    return this._httpClient.delete<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  adminApproveShift(data: any) {
    const href = environment.AUTH_API_URL + 'user-shifts/admin/approve';

    return this._httpClient.post<any>(href, data, {
      headers: this.getAuthHeaders(),
    });
  }

  acceptRejectShift(data: any) {
    const href = environment.AUTH_API_URL + 'user-shifts/shiftUpdate';

    return this._httpClient.post<any>(href, data, {
      headers: this.getAuthHeaders(),
    });
  }

  getShiftUsers(shiftId: string, search?: string) {
    let href =
      environment.AUTH_API_URL +
      'user-shifts?shiftId=' +
      shiftId +
      '&page=' +
      0 +
      '&limit=' +
      10;

    if (search) {
      href = href + '&s=' + search;
    }

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  createTicket(body: any) {
    const href = environment.AUTH_API_URL + 'threads';

    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  updateTicket(id: any, body: any) {
    const href = environment.AUTH_API_URL + 'threads/' + id;

    return this._httpClient.put<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  getTicketDetails(id: any) {
    let href = environment.AUTH_API_URL + 'threads/' + id;

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  getTicketTags() {
    let href = environment.AUTH_API_URL + 'threads/tags/getAllTags';

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  createComment(body: any) {
    const href = environment.AUTH_API_URL + 'threads-comments';

    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  getCommentsData(threadId: any) {
    let href = environment.AUTH_API_URL + 'threads-comments?threadId=' + threadId;

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  getThreads(filter: any, sort: any) {
    let href = environment.AUTH_API_URL + 'threads?page=' + 0 + '&limit=' + 100;

    if (sort != null) {
      href += "&sort=" + sort.direction;
      href += "&sortField=" + sort.active;
    }

    if (filter) {
      if (filter.selected_agencycode) {
        href += '&selected_agencycode=' + filter.selected_agencycode.join(";");
      }
      if (filter.ticket_title) {
        href += '&ticket_title=' + filter.ticket_title;
      }
      if (filter.ticket_description) {
        href += '&ticket_description=' + filter.ticket_description;
      }
      if (filter.ticket_category) {
        href += "&ticket_category=" + filter.ticket_category.join(";");
      }
      if (filter.ticket_priority) {
        href += '&ticket_priority=' + filter.ticket_priority;
      }
      if (filter.ticket_status) {
        href += '&ticket_status=' + filter.ticket_status.join(";");
      }
      if (filter?.filter_type) {
        href += '&filter_type=' + filter.filter_type + '&user_id=' + filter.user_id;
      }
    }

    if (href.indexOf("#") > -1)
      href = href.replace("#", "%23")
    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  createThreadsPriority(body: any) {
    const href = environment.AUTH_API_URL + 'threads-priority';

    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  updateThreadsPriority(id: any, body: any) {
    const href = environment.AUTH_API_URL + 'threads-priority/' + id;

    return this._httpClient.put<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  getThreadsPriority(filter: any) {
    let href = environment.AUTH_API_URL + 'threads-priority?page=' + 0 + '&limit=' + 100;

    if (filter) {
      if (filter.status) {
        href += '&status=' + filter.status;
      }
    }

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  getAgencyCodes() {
    let href = environment.AUTH_API_URL + 'agency-code?page=' + 0 + '&limit=' + 1000;

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  removePriority(id: any) {
    const href = environment.AUTH_API_URL + 'threads-priority/' + id;

    return this._httpClient.delete<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  getPriorityDetails(id: any) {
    let href = environment.AUTH_API_URL + 'threads-priority/' + id;

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  createThreadsCategory(body: any) {
    const href = environment.AUTH_API_URL + 'threads-category';

    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  updateThreadsCategory(id: any, body: any) {
    const href = environment.AUTH_API_URL + 'threads-category/' + id;

    return this._httpClient.put<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  getThreadsCategory(filter: any) {
    let href = environment.AUTH_API_URL + 'threads-category?page=' + 0 + '&limit=' + 100;

    if (filter) {
      if (filter.status)
        href += '&status=' + filter.status;
    }

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  removeCategory(id: any) {
    const href = environment.AUTH_API_URL + 'threads-category/' + id;

    return this._httpClient.delete<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  getCategoryDetails(id: any) {
    let href = environment.AUTH_API_URL + 'threads-category/' + id;

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  createThreadsStatus(body: any) {
    const href = environment.AUTH_API_URL + 'threads-status';

    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  updateThreadsStatus(id: any, body: any) {
    const href = environment.AUTH_API_URL + 'threads-status/' + id;

    return this._httpClient.put<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  getThreadsStatus(filter: any) {
    let href = environment.AUTH_API_URL + 'threads-status?page=' + 0 + '&limit=' + 100;

    if (filter) {
      if (filter.status) {
        href += '&status=' + filter.status;
      }
    }

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  removeStatus(id: any) {
    const href = environment.AUTH_API_URL + 'threads-status/' + id;

    return this._httpClient.delete<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  getStatusDetails(id: any) {
    let href = environment.AUTH_API_URL + 'threads-status/' + id

    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  updateUserTags(tags, email) {
    let href = environment.AUTH_API_URL + 'user/update/tags';

    let body = {
      tags: tags,
      email: email
    }

    return this._httpClient.put<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  updateThreadTags(tags, email) {
    let href = environment.AUTH_API_URL + 'threads/updateTags';

    let body = {
      tags: tags,
      email: email
    }

    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  postFeedback(newFeedback) {
    let href = environment.AUTH_API_URL + 'feedback/postFeedback';

    return this._httpClient.post<any>(href, newFeedback, {
      headers: this.getAuthHeaders(),
    });
  }

  updateAlertGroup(connectionId, group) {
    let href = environment.AUTH_API_URL + 'connections/updateAlertGroup';

    let payload = {
      connectionId: connectionId,
      group: group
    }

    return this._httpClient.post<any>(href, payload, {
      headers: this.getAuthHeaders(),
    });
  }

  getApps() {
    const href = environment.AUTH_API_URL + 'apps';
    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  getAllApps() {
    const href = environment.AUTH_API_URL + 'apps/all';
    return this._httpClient.get<any>(href, {
      headers: this.getAuthHeaders(),
    });
  }

  updateApp(body: any) {
    const href = environment.AUTH_API_URL + 'apps/admin/edit';
    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  createApp(body: any) {
    const href = environment.AUTH_API_URL + 'apps/admin/create';
    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  assignUserToApp(body: any) {
    const href = environment.AUTH_API_URL + 'apps/admin/assignUser';
    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  removeUserFromApp(body: any) {
    const href = environment.AUTH_API_URL + 'apps/admin/removeUser';
    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  getAppUsers(body: any) {
    const href = environment.AUTH_API_URL + 'apps/admin/getUsers';
    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

  deleteApp(body: any) {
    const href = environment.AUTH_API_URL + 'apps/admin/delete';
    return this._httpClient.post<any>(href, body, {
      headers: this.getAuthHeaders(),
    });
  }

}
